import React, { useEffect } from "react";
import { useState } from "react";
import "../Login/login.css";
import { useNavigate,Link } from "react-router-dom";
import { login } from "../../api/axios";
import { CircularProgress } from "@mui/material";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { IoEyeSharp, IoEyeOffSharp } from 'react-icons/io5';

function Login() {

  // useEffect(() => {
  //     localStorage.clear();
  // }, []);

  let navigate = useNavigate();
  //initial state of the input fields
  const initialvalues = { username: "", password: "" };
  const [Values, setValues] = useState(initialvalues);
  const [Errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  //Han
  //Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...Values, [name]: value });
  };

  //send data
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors(validate(Values));
    console.log(Values);
    if (Values.username !== "" && Values.password !== "") {
      setLoading(true);
      var data = {
        admin_name: Values.username,
        password: Values.password,
      };
      try {
        const res = await login(data);
        console.log(res.data);
        if (res.data.success) {
          localStorage.setItem("userID", res.data.sub.id);
          let token = res.data.token.slice(7);
          localStorage.setItem("token", token);
          navigate("/home");
        } else {
          localStorage.clear();
          // window.location.reload();
          let error = {
            message: res.data.message,
          };
          setErrors(error);
        }
        setLoading(false);
      } catch (err) {
        console.log(err);
        setLoading(false);
      }
    }
  };

  //validation
  const validate = (values) => {
    const errors = {};
    if (!values.username) {
      errors.username = "Username is required!";
    }
    if (!values.password) {
      errors.password = "Password is required!";
    } else if (values.password.length < 8) {
      errors.password = "Password must be more than 8 characters!";
    } else if (values.password.length > 50) {
      errors.password = "Password cannot exceed more than 50 characters!";
    }
    return errors;
  };

  return (
    <div className="cont">
      <form>
        <h1>Log In</h1>
        {Errors.message && <p className="text-danger">{Errors.message}</p>}
        <div className="field">
          <label>Username</label>
          <input
            type="text"
            name="username"
              className="form-control textarea"
            value={Values.username}
            onChange={handleChange}
          />
        </div>
        {Errors.username && <p className="text-danger">{Errors.username}</p>}
        <div className="field">
          <label>Password</label>
          <div className="password-field position-relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              className="form-control textarea"
              value={Values.password}
              onChange={handleChange}
            />
            <button
              type="button"
              className="btn btn-link position-absolute"
              style={{
                padding:'0px',
                color: 'rgb(0, 0, 0)',
                right: '7%',
                width: 'auto',
                margin: 0,
                height: '100%',
                bottom: '0',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                marginTop: '-10px',
              }}
              onClick={handleClickShowPassword}
            >
              {showPassword ? <IoEyeOffSharp size={20} /> : <IoEyeSharp size={20}  />}
            </button>
          </div>
        </div>
        {Errors.password && <p className="text-danger">{Errors.password}</p>}
        <div className="middle">
          <div className="right">
            <label>
              <p className="mb-0">
                Forgot password?
                <Link to="/forgetpassword" className="text-decoration-none">
                  {" "}
                  <u>Reset your password here</u>
                </Link>
              </p>
            </label>
          </div>
        </div>
        <button 
          id="btn1" 
          className="btn-primary w-100" 
          onClick={handleSubmit}
          disabled={loading}
        >
         {loading ? (
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          ) : (
            "Log In"
          )}
        </button>
      </form>
    </div>
  );
}

export default Login;
